export default __webpack_public_path__ + "static/media/img-slider-handigo-2.6b4be5f3.png";